import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "current-offer__flight-header" }
const _hoisted_2 = { class: "current-offer__right-container" }
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = { key: 0 }

import type { MergedOfferItemData } from '@/interfaces/offer';
import FeatureList from '@lmt-rpb/FeatureList/FeatureList.vue';
import FlightContainer from './FlightContainer.vue';
import FlightSegment from './FlightSegment.vue';
import RoundedButton from '@lmt-rpb/RoundedButton/RoundedButton.vue';
import PriceRow from './PriceRow.vue';
import { useTemplateRef } from 'vue';
import OfferDetailsModal from '@lmt-rpb/OfferDetailsModal/OfferDetailsModal.vue';
import CheckoutFlightDetails from '@lmt-rpb/CheckoutFlightDetails/CheckoutFlightDetails.vue';
import { useTranslations } from '@helper/composables/translations';

type Props = {
	offerData: MergedOfferItemData;
	checkoutUrl: string;
	price: { amount: number | null; currency: 'EUR' | 'CHF' | undefined };
};


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrentOffer',
  props: {
    offerData: {},
    checkoutUrl: {},
    price: {}
  },
  setup(__props: any) {

const { translate } = useTranslations();


const flightDetailsModal = useTemplateRef('flightDetailsModal');

const showModal = (): void => {
	flightDetailsModal.value?.open();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FlightContainer, {
      class: "current-offer",
      "button-theme": "extra",
      onShowFlightDetails: showModal
    }, {
      header: _withCtx(() => [
        _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(translate)('alternativeFlights.currentOffer')), 1 /* TEXT */)
      ]),
      outbound: _withCtx(() => [
        _createVNode(FlightSegment, {
          "flight-segments": _ctx.offerData.OutboundFlightSegments,
          duration: _ctx.offerData.OutboundFlight?.Duration
        }, null, 8 /* PROPS */, ["flight-segments", "duration"])
      ]),
      inbound: _withCtx(() => [
        _createVNode(FlightSegment, {
          "flight-segments": _ctx.offerData.InboundFlightSegments,
          duration: _ctx.offerData.InboundFlight?.Duration
        }, null, 8 /* PROPS */, ["flight-segments", "duration"])
      ]),
      right: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FeatureList, { offer: _ctx.offerData }, null, 8 /* PROPS */, ["offer"]),
          (_ctx.offerData.TourOperator)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "current-offer__tour-operator",
                src: _ctx.offerData.TourOperator.Image,
                alt: _ctx.offerData.TourOperator.Name,
                title: _ctx.offerData.TourOperator.Name
              }, null, 8 /* PROPS */, _hoisted_3))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      price: _withCtx(() => [
        (_ctx.price.amount)
          ? (_openBlock(), _createBlock(PriceRow, {
              key: 0,
              class: "current-offer__price",
              "price-props": { price: _ctx.price.amount, currency: _ctx.price.currency, showDecimals: true, theme: 'accent' },
              "font-size": "extralarge"
            }, null, 8 /* PROPS */, ["price-props"]))
          : _createCommentVNode("v-if", true)
      ]),
      button: _withCtx(() => [
        _createVNode(RoundedButton, {
          class: "current-offer__booking",
          theme: "extra",
          as: "a",
          href: _ctx.checkoutUrl
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)('offer.addToCart')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(OfferDetailsModal, {
      ref_key: "flightDetailsModal",
      ref: flightDetailsModal,
      class: "alternative-flight__flight-details-modal",
      title: _unref(translate)('offer.flight.details')
    }, {
      default: _withCtx(() => [
        (_ctx.offerData?.InboundFlightSegments && _ctx.offerData?.OutboundFlightSegments)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(CheckoutFlightDetails, {
                "inbound-flight": _ctx.offerData.InboundFlightSegments,
                "outbound-flight": _ctx.offerData.OutboundFlightSegments,
                "has-stopover": !!(_ctx.offerData?.InboundFlightSegments.length > 1 || _ctx.offerData.OutboundFlightSegments.length > 1)
              }, null, 8 /* PROPS */, ["inbound-flight", "outbound-flight", "has-stopover"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["title"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})